import { z } from 'zod'
import type { Application } from '#/domain/application/Application'

export const ApplicationDtoSchema = z
  .object({
    Id: z.string(),
    Slug: z.string(),
    Title: z.string().nullish(),
    Description: z.string().nullish(),
    Tag: z.string().nullish(),
    Link: z.string().nullish(),
    Image: z.string(),
    Permission: z.string().nullish(),
    ButtonOnly: z.string().nullish(),
    SortOrder: z.number(),
  })
  .transform((raw): Application => ({
    id: raw.Id,
    slug: raw.Slug,
    title: raw.Title ?? undefined,
    description: raw.Description ?? undefined,
    tag: raw.Tag ?? undefined,
    link: raw.Link ?? undefined,
    image: raw.Image,
    permission: raw.Permission ?? undefined,
    buttonOnly: raw.ButtonOnly ?? undefined,
    sortOrder: raw.SortOrder,
  }))

export type ApplicationResponseDto = z.input<typeof ApplicationDtoSchema>

export function toDomain(raw: ApplicationResponseDto): Application {
  return ApplicationDtoSchema.parse(raw)
}

export function toDomainList(raw: ApplicationResponseDto[]): Application[] {
  return raw.map(toDomain)
}
